import { render, staticRenderFns } from "./studyChat.vue?vue&type=template&id=bad9f876&"
import script from "./studyChat.vue?vue&type=script&lang=js&"
export * from "./studyChat.vue?vue&type=script&lang=js&"
import style0 from "./studyChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports